import getLocalTrigger from "../../../utils/get-local-trigger";
import initImmediateChecks from "./init-immediate-checks";
import initImmediateClasses from "./init-immediate-classes";

/**
 * Initialize events, that should be immediate triggered after page load
 * @param {Map<TorusElement, MainClassProps> | null} [targets]
 */
const initImmediate = (targets) => {
  /** Get all "animate" triggers */
  const classes = /** @type {GlobalSingleTriggerProps} */ (
    getLocalTrigger("class", targets)
  );
  const changes = /** @type {GlobalSingleTriggerProps} */ (
    getLocalTrigger("change", targets)
  );

  /** Init element classes */
  initImmediateClasses(classes);

  /** Init checkboxes */
  initImmediateChecks(changes);
};

export default initImmediate;
